import { render, staticRenderFns } from "./SocleNotificationApprovalWorkflowEdit.vue?vue&type=template&id=f40604ce&"
import script from "./SocleNotificationApprovalWorkflowEdit.vue?vue&type=script&lang=ts&"
export * from "./SocleNotificationApprovalWorkflowEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports